import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import 'react-custom-scroll/dist/customScroll.css';
import CustomScroll from 'react-custom-scroll';
import theme from '../../../theme';

// react-custom-scroll does not allow setting the className, thus styled components does not work
// => as a workaround, we wrap the component
const CustomScrollBase = ({ className, ...other }) => (
  <div className={className}>
    <CustomScroll {...other} />
  </div>
);
CustomScrollBase.propTypes = {
  className: PropTypes.string,
};
CustomScrollBase.defaultProps = {
  className: '',
};

const ScrollBar = styled(CustomScrollBase)`
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: 100%;
    
  .rcs-custom-scroll {
    min-height: 0;
    min-width: 0; 
    & .rcs-outer-container {
      overflow: hidden; 
      & .rcs-positioning {
        position: relative; }
      &:hover .rcs-custom-scrollbar {
        opacity: 1;
        transition-duration: 0.2s; 
        }
     }
    & .rcs-inner-container {
      overflow-x: hidden;
      overflow-y: scroll;
      -webkit-overflow-scrolling: auto; 
      &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 0;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.05) 60%, transparent 100%);
        pointer-events: none;
        transition: height 0.1s ease-in;
        will-change: height; }
      &.rcs-content-scrolled:after {
        height: 5px;
        transition: height 0.15s ease-out; }
      }
    & .rcs-custom-scrollbar {
      position: absolute;
      height: 100%;
      width: 6px;
      right: 3px;
      opacity: 0;
      z-index: 1;
      transition: opacity 0.4s ease-out;
      padding: 6px 0;
      box-sizing: border-box;
      will-change: opacity;
      pointer-events: none;
        &.custom-scrollbar-rtl {
          right: auto;
          left: 3px; }
      }    
    &.rcs-scroll-handle-dragged {    
      & .inner-container {
        user-select: none; }    
      & .custom-scrollbar {
        opacity: 1; }
    }
    & .rcs-custom-scroll-handle {
      position: absolute;
      width: 100%;
      top: 0; 
      & .rcs-inner-handle {
        height: calc(100% - 12px);
        margin-top: 6px;
        background-color: ${(props) => props.color};
        border-radius: 3px; 
      }
    }
  }
`;


ScrollBar.propTypes = {
  allowOuterScroll: PropTypes.bool,
  heightRelativeToParent: PropTypes.string,
  flex: PropTypes.number,
  onScroll: PropTypes.func,
  addScrolledClass: PropTypes.bool,
  freezePosition: PropTypes.bool,
  minScrollHandleHeight: PropTypes.number,
  rtl: PropTypes.bool,
  scrollTo: PropTypes.bool,
  keepAtBottom: PropTypes.bool,
  color: PropTypes.string,
};
ScrollBar.defaultProps = {
  allowOuterScroll: false,
  addScrolledClass: false,
  freezePosition: false,
  minScrollHandleHeight: 38,
  rtl: false,
  keepAtBottom: false,
  heightRelativeToParent: '100%',
  color: theme.colors.medium,
};

export default ScrollBar;
